import React               from 'react';
import reactStringReplace  from 'react-string-replace';
import { Link }            from 'react-router-dom';
import LocaleString        from '../../shared/locale-string';
import { CloseCircleIcon } from '../../shared/icons/icons.jsx';

import './cookie-notice.scss';

export const CookieNotice = ( props ) => {
    const handleClick = event => {
        event.preventDefault();
        props.handleAcknowledge();
    };

    const { loaded, cookieNoticeContent } = props;
    const { hasAcknowledged, version } = props.privacyNotice;
    const showNotice = ( version > 0 && !hasAcknowledged && loaded );

    return (
        <div className={ `cookie-notice ${ showNotice ? 'visible' : '' }` }>
            <span className="cookie-notice-content">
            {
                reactStringReplace( cookieNoticeContent, '${privacyNoticeLink}', ( match, i ) => (
                  <Link key={ i } to="/privacy-notice"><LocaleString code="privacy.notice.linkLabel" /></Link>
                ) )
            }
            </span>
            <button className="btn-close" onClick={ handleClick } type="button">
                <span className="close-label sr-only">Close</span>
                <span className="close-icon"><CloseCircleIcon /></span>
            </button>
        </div>
    );
};

export default CookieNotice;
